import { graphConfig } from "./authConfig";

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */
export async function callMsGraph(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

export async function callGraphEmail(accessToken, toAddress, roomNumber) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
            "message": {
                "subject": 'Assistance Needed Urgently',
                "body": {
                    "contentType": 'Text',
                    "content": 'Please send administration or a school officer to room ' + roomNumber +' ASAP.'
                },
                "toRecipients": [
                    {
                        "emailAddress": {
                            "address": toAddress
                        }
                    }
                ],
            }
        })

    };

    return fetch(graphConfig.graphSendEndpoint, options)
        .then((response) => {
            console.log(response);
            alert("An email has been sent on your behalf. Please stay safe.");
        })
        .catch(error => console.log(error));
}